export default "__VITE_PUBLIC_ASSET__579a95d4__"